// Libs
import React from 'react';
import { Tooltip, Icon, Collapse } from 'antd';
import { ColumnProps } from 'antd/lib/table';

// Own Libs
import { Button, Table, Widget } from '@digital/ui';

//Api
import { DemandaComRequisicao } from '@app/api/requisitanteCapex';

//Files

//Utils
import { compareText } from '@app/helpers/comparators';
import { currencyFormat } from '@app/helpers/numbers';
import { mountFormFilterDropDown } from '@app/utils/formFilterDropDown';

const { Panel } = Collapse;

interface TabelaDemandasValiadadaCanceladaProps {
  dataSourceResult: DemandaComRequisicao[];
  widgettitle: string;
  urlDemanda: string;
  aba: string;
}

const TabelaDemandasValiadadaCancelada = ({
  dataSourceResult,
  widgettitle,
  urlDemanda,
  aba }: TabelaDemandasValiadadaCanceladaProps) => {

  const columns: ColumnProps<DemandaComRequisicao>[] = [
    {
      title: 'Código',
      dataIndex: 'identificadorTexto',
      sorter: (a, b) => compareText(a.identificadorTexto, b.identificadorTexto),
      ...mountFormFilterDropDown('identificadorTexto', 'Pesquisar'),
      // fixed: 'left',
    },
    {
      title: 'Abertura',
      dataIndex: 'dataAberturaDemandaString',
    },
    {
      title: 'Demandante',
      dataIndex: 'demandante',
    },
    {
      title: 'Dir',
      dataIndex: 'diretoria',
    },
    {
      title: 'Área',
      dataIndex: 'area',
    },
    {
      title: 'Depto',
      dataIndex: 'departamento',
    },
    {
      title: 'Tipo',
      dataIndex: 'tipoDescricao',
      sorter: (a, b) => compareText(a.tipoDescricao, b.tipoDescricao),
      ...mountFormFilterDropDown('tipoDescricao', 'Pesquisar'),
    },
    {
      title: 'Tipo de Serviço',
      dataIndex: 'tipoServico',
      sorter: (a, b) => compareText(a.tipoServico, b.tipoServico),
      ...mountFormFilterDropDown('tipoServico', 'Pesquisar'),
    },
    {
      title: 'Valor Final',
      dataIndex: 'expectativaValorFinal',
      render: (text, record) => currencyFormat(record.expectativaValorFinal),
    },
    {
      title: 'Status',
      dataIndex: 'statusHistoricoDescricao',
      sorter: (a, b) => compareText(a.statusHistoricoDescricao, b.statusHistoricoDescricao),
      ...mountFormFilterDropDown('statusHistoricoDescricao', 'Pesquisar'),
      render: (text, record, index) => record.statusHistoricoDescricao.toLowerCase().includes('aprovou')
        ? 'Validada'
        : 'Reprovada'
    },
    {
      title: 'Ações',
      render: (index, record) => (
        <Tooltip title="Ir para Demanda">
          <Button
            type="link"
            icon="arrows-circled_up_right_2"
            name="irparaBm"
            onClick={() => {
              const urlBase = window.location.origin;
              window.open(urlBase + `${urlDemanda}${record.id}${aba}`);
            }}
            href="#"
          />
        </Tooltip>
      ),
      width: '1%',
      // fixed: 'right',
    },
  ];

  return (
    <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />} defaultActiveKey={[widgettitle]}>
      <Panel key={widgettitle} header={widgettitle} style={{ border: 0 }}>
        <Widget>
          <Table columns={columns} dataSource={dataSourceResult} />
        </Widget>
      </Panel>
    </Collapse>
  );
};
export default TabelaDemandasValiadadaCancelada;
